import { APP_PERMISSIONS } from '@exam-center/permission';
import { type PermissionRouteData, PermissionRoute } from '@exam-center/router';
import { useMemo } from 'react';

interface ExamCenterDetailsPermissionRouteProps {
  examCenterCode: string;
}

export default function ExamCenterDetailsPermissionRoute(
  props: Readonly<ExamCenterDetailsPermissionRouteProps>,
) {
  const { examCenterCode } = props;

  const routes = useMemo<PermissionRouteData[]>(
    () => [
      {
        path: '/:examCenterCode/details',
        params: { examCenterCode },
        requiredPermission: [APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW],
      },
      {
        path: '/:examCenterCode/details/members',
        params: { examCenterCode },
        requiredPermission: [APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.MEMBER.VIEW],
      },
      {
        path: '/:examCenterCode/details/courses',
        params: { examCenterCode },
        requiredPermission: [APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW],
      },
    ],
    [examCenterCode],
  );
  return <PermissionRoute routes={routes} />;
}
